import ApprovedDocumentsActions from './ApprovedDocumentsActions';
import React, { Component } from "react";
import ReactDOM from 'react-dom';
import axios from "axios";
import { DOC2SIGN_DOCUMENT_TYPE } from '../constants';
import { LangContext } from "../LangContext.jsx";
import DocumentsActions from "./DocumentsActions.jsx";
import PreviewFile from "./PreviewFile.jsx";
import { showFile } from '../functions';
class DossierDocumentsDeleteTable extends Component {
    static contextType = LangContext;
    constructor(props) {
        super();
        this.state = {
            selectedDocuments: {},

        };
    }

    handleSelectDocument = (id) => {
        const updatedDocuments = this.props.documents.map(doc => { 
            if (doc.id == id) {
                return { ...doc, selected: !doc.selected }; // Cambiamos la propiedad `selected`
            }
            return doc; // Devolvemos el documento sin cambios si no coincide el ID
        });
        const selectedDoc = updatedDocuments.find(doc => doc.id === id);
        this.props.onSelectDocument(updatedDocuments,this.props.section, this.props.status,selectedDoc ? selectedDoc.selected : false);
    }; 
    traducirPalabra = (palabra)=>{ 
        const { lang } = this.context;  
        if(palabra == '(es)'){
            return '';
        }
        return lang.get('messages.'+palabra.toLowerCase().replace(/\s+/g, '_').replace(/\s+/g, '_').replace(/[()]/g, '').normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '').replace(/,/g, ''))
    }
    translatePeriod = (texto) => {
        if (texto === null || texto === undefined) {
            return ''; 
            }
            const palabras = texto.split(/\s+/);
            const textoTraducido = palabras.map((palabra) => this.traducirPalabra(palabra)).join(' ');
            return textoTraducido;
    }
    render() {
        const { lang } = this.context; 
        return (
            <>
            {this.props.showRejectedMessage ? (
            <>
                <tr>
                <td colSpan="6">
                    <div className="separator separator-solid separator-border-1 mt-5 mb-2" style={{ borderBottomColor: "#dbcbfd" }}></div>
                </td>
                </tr>
                <tr>
                <td colSpan="2"> <h5 className="py-5">{this.props.title}</h5> </td>
                <td colSpan="2"> 
                    <div className="py-5">
                    <h5>{lang.get('messages.motivo_de_rechazo')}</h5>
                    </div>
                </td>
                <td colSpan="2"></td>
                </tr>
            </>
            ) : (
            <tr>
                <td colSpan="6">
                <div className="separator separator-solid separator-border-1 mt-5 mb-2" style={{ borderBottomColor: "#dbcbfd" }}></div>
                <h5 className="py-5">{this.props.title}  </h5>
                </td>
            </tr>
            )}
            {this.props.documents?.map((d, i) => (
            <tr key={i}>
                <td style={{width: "20px"}}> 
                    <label className="checkbox checkbox-outline align-items-center mb-2"> 
                        <input type="checkbox"   name="extensions"  checked={d.selected || false}onChange={() => this.handleSelectDocument(d.id)}/>
                            <span className="w-25px h-25px mt-2 rounded-0"></span>
                    </label>
                </td>
                <td style={{width: "20px"}} className='d-flex'>
                
                {
                    d.document.type_id == DOC2SIGN_DOCUMENT_TYPE
                    ? <img src="/assets/img/doc2sign.svg"/>
                    : <img src={"/assets/img/" + window.getMimeSVG(d?.file?.extension !== undefined ? d?.file?.extension : d?.file?.path)} />
                } 
                </td>
                <td colSpan={this.props.showRejectedMessage ? "" : "2"} >  
                {`${d.document.title} ${d.document.version > 1 ? `V${d.document.version}` : ''}`} 
                {this.props.type == "recurrent"   &&
                <span className="tooltip-mdl">
                    <span><strong> &nbsp; - {d.description_period}  </strong></span> 
                    <span className="tooltip-text-mdl">{this.translatePeriod(d.document.period) }</span> 
                </span>  
                }  
                &nbsp; 
                <div className="text-dark-65 font-size-sm">
                ({lang.get('messages.solicitado_el')} {d.requestedDate}
                { (d?.upload_date?.created && d.document.type_id !== DOC2SIGN_DOCUMENT_TYPE && d.document.type_id !== 2) && (
                    <> - {lang.get('messages.cargado_el')} {d.upload_date.created} </>
                )}
                { (d?.approval_date.created != null && d.document.type_id !== DOC2SIGN_DOCUMENT_TYPE )&& (
                    <> - {lang.get('messages.aprobado_el')} {d.approval_date.created} </>
                )}
                { (d?.rejected_date.created != null &&  this.props.title == 'Rechazados' )  && (
                    <> - {lang.get('messages.rechazado_el')} {d.rejected_date.created} </>
                )}
                {(d?.expiration_date &&  this.props.title != 'Rechazados'  && this.props.type == "recurrent")&& (
                    <> - {lang.get('messages.expira_el')} {d.expiration_date} </>
                )}
                { d?.signed_date != null && (
                    <> - {lang.get('messages.firmado_el')} {d.signed_date.created} </>
                )}
                
                )
                </div>
                </td>
                {this.props.showRejectedMessage &&
                <>
                <td colSpan="2"  style={{ maxWidth: "200px" }}>  {d?.status_comment}</td>
                </> }
                
                {(this.props.title == 'Aprobados / Firmados' && this.props.type=="recurrent") &&
                <ApprovedDocumentsActions document={d} person_provider_id={this.props.personProviderId} />
                }
                {(this.props.type == 'only' || this.props.type == 'recurrent' && this.props.title != 'Aprobados / Firmados')&&
                <td colSpan="2" className="text-right">  
                { (d?.file?.extension == 'pdf' || d?.file?.extension == 'png' || d?.file?.extension == 'jpg' || d?.file?.extension == 'jpeg' || d?.file?.extension == 'gif' || d?.file?.extension == 'svg' ) &&
                <>
                    <a 
                        href="#" 
                        onClick={() => showFile( `/files/${d.id}` , d.file.extension)}
                        className="text-primary"
                    >
                    <span className="flaticon2-file-2 mr-2"></span>Vista Previa
                    </a>
                </>
                }
                    {(d?.file?.extension == 'doc' || d?.file?.extension == 'docx') &&
                <>
                    <PreviewFile  doc={d}/> 
                </>
                }
                </td>
                }
            </tr>
            ))}
            </>
        );
    }
}
export default DossierDocumentsDeleteTable;

if (document.getElementById('DossierDocumentsDeleteTable')) {
    ReactDOM.render(<DossierDocumentsDeleteTable />, document.getElementById('DossierDocumentsDeleteTable'));
}
